export default function formatDate(date: Date | string | number, format: string, locale?: string) {
  return useDateFormat(new Date(date || ""), format, { locales: locale || "en" }).value;
}
